import { render, staticRenderFns } from "./IdentificationType.vue?vue&type=template&id=0e7fa4cc&scoped=true"
import script from "./IdentificationType.vue?vue&type=script&lang=js"
export * from "./IdentificationType.vue?vue&type=script&lang=js"
import style0 from "./IdentificationType.vue?vue&type=style&index=0&id=0e7fa4cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fa4cc",
  null
  
)

export default component.exports